import DOMPurify, { Config } from 'dompurify';

import { INullable } from 'utils/types';

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

// Markup the rich editor and the notification service produce; no frames, forms, styles or SVG.
const STRICT_HTML_CONFIG: Config = {
  ALLOW_DATA_ATTR: false,
  ALLOWED_ATTR: [
    'alt',
    'data-id',
    'data-mention',
    'data-prefix',
    'data-value',
    'href',
    'rel',
    'src',
    'target',
    'title',
  ],
  ALLOWED_TAGS: [
    'a',
    'b',
    'blockquote',
    'br',
    'code',
    'del',
    'div',
    'em',
    'figure',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'i',
    'img',
    'ins',
    'li',
    'ol',
    'p',
    'pre',
    's',
    'span',
    'strong',
    'sub',
    'sup',
    'u',
    'ul',
  ],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
};

export const sanitizeHtml = (html?: INullable<string>) =>
  html ? DOMPurify.sanitize(html, STRICT_HTML_CONFIG) : '';
